<script lang="ts" setup>
import type { OperationModel } from "~/core/models/OperationModel.interface";
import { OperationModelType } from "~/core/models/OperationModelType.enum";
import type { Dtwin } from "~/modules/dtwin/models/Dtwin.interface";
import { DtwinFormOperationListColumns } from "~/modules/dtwin/models/DtwinFormOperationListColumns.enum";
import type { DtwinModel } from "~/modules/dtwin/models/DtwinModel.interface";
import type { DtwinOperation } from "~/modules/dtwin/models/DtwinOperation.interface";
import type { DtwinOperationFirmwareInputParameters } from "~/modules/dtwin/models/DtwinOperationFirmwareInputParameters.interface";

defineProps<{
  organizationCode: number;
  dtwin: Dtwin;
  dtwinModel: DtwinModel;
  dtwinOperationModel: OperationModel;
  reload: boolean;
}>();

const columns: DtwinFormOperationListColumns[] = [
  DtwinFormOperationListColumns.VERSION,
  DtwinFormOperationListColumns.CREATED_AT,
  DtwinFormOperationListColumns.LAUNCHED_AT,
  DtwinFormOperationListColumns.MODIFIED_AT,
  DtwinFormOperationListColumns.STATUS,
];

const operationFormShown = ref(false);
const operationFormModel: Ref<
  DtwinOperation<DtwinOperationFirmwareInputParameters> | undefined
> = ref();

const baseComponentRef = ref<
  (ComponentPublicInstance & { reload: () => Promise<void> | void }) | undefined
>();

const reloadWithContext = () => {
  baseComponentRef.value?.reload();
};

function showOperationForm(
  operation: DtwinOperation<DtwinOperationFirmwareInputParameters>,
) {
  operationFormModel.value = operation;
  operationFormShown.value = true;
}

defineExpose({
  reload: reloadWithContext,
});
</script>

<template>
  <dtwin-form-operation
    ref="baseComponentRef"
    :organization-code="organizationCode"
    :dtwin="dtwin"
    :dtwin-model="dtwinModel"
    :dtwin-operation-model="dtwinOperationModel"
    :operation-type="OperationModelType.FIRM_UPDATE"
    :reload="reload"
    show-custom-column
    :columns="columns"
    @edit="showOperationForm"
  />

  <dtwin-form-firmware-update-modal
    v-model:show="operationFormShown"
    :organization-code="organizationCode"
    :dtwin="dtwin"
    :dtwin-model="dtwinModel"
    :dtwin-operation-model="dtwinOperationModel"
    :operation="operationFormModel"
    @change="reloadWithContext"
  />
</template>
